module.exports = __webpack_public_path__ + "img/Dashboard-REP.4b514a79.svg";